import { render, staticRenderFns } from "./Incoterms.vue?vue&type=template&id=573138cf&scoped=true&"
import script from "./Incoterms.vue?vue&type=script&lang=js&"
export * from "./Incoterms.vue?vue&type=script&lang=js&"
import style0 from "./Incoterms.vue?vue&type=style&index=0&id=573138cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573138cf",
  null
  
)

/* custom blocks */
import block0 from "./Incoterms.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports